const _ = require('lodash'), shelfBundleCardFactory = require('../shelfproduct/shelfbundle-card-factory');

module.exports = function (settingsService, specialsGroupsService) {
    return {
        restrict: 'E',
        scope: {},
        require: '^wowCardList',
        link(scope, element, attrs, cardListCtrl) {
            function getProducts(pageSize, pageNumber, sortType) {
                // Default args
                const args = {
                    pageNumber,
                    pageSize: pageSize || 10,
                    sortType
                };
                if (specialsGroupsService.isAllSpecialsSelected()) {
                    return specialsGroupsService.getAllSpecialsProducts(args);
                } else if (specialsGroupsService.selectedGroup) {
                    return specialsGroupsService.getProducts(_.merge(args, {
                        specialsGroup: specialsGroupsService.selectedGroup
                    }));
                }
            }

            function createCards(products) {
                return {
                    totalRecordCount: products.totalRecordCount,
                    items: shelfBundleCardFactory.createBundleCards(products.items)
                };
            }

            // Product provider function
            function getCards(pageSize, pageNumber, sortType) {
                return getProducts(pageSize, pageNumber, sortType)
                    .then(createCards);
            }

            function containRecency(sortTypes) {
                for (let i = 0; i < sortTypes.length; i++) {
                    if (sortTypes[i].Text === 'Recency') {
                        return true;
                    }
                }
                return false;
            }

            // Add the recency option for YourSpecials. Do not show recency for other pages.
            function filterSortBy(sortTypes) {
                if (specialsGroupsService.isMySpecialsSelected() && !containRecency(sortTypes)) {
                    sortTypes.push({ Text: 'Recency', Value: 'Recency' });
                } else if (!specialsGroupsService.isMySpecialsSelected() && containRecency(sortTypes)) {
                    // Remove the last option from sort types which is Recency
                    sortTypes.pop();
                }
                return sortTypes;
            }

            function getSortOptions() {
                return settingsService.getSettingValue('Specials', 'SortOptions').then(function (sortTypes) {
                    return {
                        sortTypes: filterSortBy(sortTypes),
                        sortContext: 'Specials'
                    };
                });
            }

            function getTitle() {
                if (specialsGroupsService.selectedGroup) {
                    let title = specialsGroupsService.selectedGroup.Name;

                    // Only show the product count if non-zero
                    if (specialsGroupsService.selectedGroup.ProductCount) {
                        title += ` (${specialsGroupsService.selectedGroup.ProductCount})`;
                    }
                    return title;
                }

                return 'Specials';
            }

            cardListCtrl.setOptions({
                getCards,
                getSortOptions,
                getTitle,
                smallerProductStampsEnabled: true
            });

            scope.$watch(
                function () {
                    return specialsGroupsService.selectedGroup;
                }, _.debounce(function (value) {
                    if (value) {
                        cardListCtrl.update();
                    }
                }, 100)
            );
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-group-products-directive.js
 **/